import { getCurrentHostname } from '@/helpers/conf';

export const normalizeSubscriptionUrl = (url: string | undefined) => {
  if (!url) return;
  const parsed = new URL(url);
  if (parsed.hostname.startsWith('app.')) {
    parsed.hostname = `www.${getCurrentHostname(window.location.hostname)}`;
  }
  return parsed.toString();
};
